module.exports = __webpack_public_path__ + "img/family_top.371b7c65.png";